import { createFileRoute } from "@tanstack/react-router";
import { FloorPage } from "../features/floor/floor-page";
import { Require } from "../features/require";

export const Route = createFileRoute("/tables")({ component: Page });

function Page() {
	return (
		<Require permission="order.create">
			<FloorPage />
		</Require>
	);
}
